import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = "/auth",
}) => {
  const { user, loading, session } = useAuth();
  const location = useLocation();

  // Check if user is in password reset flow
  const isResettingPassword =
    sessionStorage.getItem("isResettingPassword") === "true";

  // Allow access to reset password page even without full authentication
  if (isResettingPassword && location.pathname === "/reset-password") {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#eeeff6]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primarycolor-1 mx-auto mb-4"></div>
          <p className="text-[#373e46] font-medium">Memuat...</p>
        </div>
      </div>
    );
  }

  // Prioritize session over user profile for faster access
  if (!session) {
    return <Navigate to={redirectTo} replace />;
  }

  // If we have a session but no user profile yet, allow access
  if (session && !user) {
    // Session exists but user profile still loading, allowing access
  }

  return <>{children}</>;
};
